// extracted by mini-css-extract-plugin
var _1 = "Badge_animation__46000";
var _2 = "Badge_badge__ffa26";
var _3 = "Badge_count__06d79";
var _4 = "Badge_dot__857da";
var _5 = "Badge_left__bed6e";
var _6 = "Badge_medium__55388";
var _7 = "Badge_mini__3cd75";
var _8 = "Badge_right__ff697";
var _9 = "Badge_root__96b3a";
export { _1 as "animation", _2 as "badge", _3 as "count", _4 as "dot", _5 as "left", _6 as "medium", _7 as "mini", _8 as "right", _9 as "root" }
